// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608041441/js/" + chunkId + "." + {"44":"2c390474","225":"aac3ca15","481":"beb2ab11","486":"d9299176","770":"d2c5c6df"}[chunkId] + ".0.9973621646873689.chunk.js";
};